import React from 'react';
const stats = [{
  emoji: '🗂',
  label: '6 operating volumes'
}, {
  emoji: '🧰',
  label: '75 printable templates'
}, {
  emoji: '⏱',
  label: 'One 20-minute weekly reset'
}, {
  emoji: '📄',
  label: 'Letter + A4, same source'
}];
const coverage = ['The year', 'The week', 'Daily anchors', 'Records', 'Space, supplies & paper', 'Review & sustainability'];
export function ProductReveal() {
  return <section aria-labelledby="product-heading" className="w-full bg-white" data-id="element-215" data-mp="2defhpz8yrv7c">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20 text-center" data-id="element-216" data-mp="28et61u8san0n">
        <p className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cream border border-cream-dark text-ink-soft text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em]" data-id="element-217" data-mp="2n376xzmn41ek">
          <span aria-hidden="true" data-id="element-218" data-mp="1umwhu1a8kx9j">🗂</span>
          The complete operations layer for families who already homeschool
        </p>

        <h2 id="product-heading" className="mt-6 font-serif font-black text-ink text-3xl sm:text-5xl tracking-tight" data-id="element-219" data-mp="1pol8drnusoru">
          Homeschool, Handled.
        </h2>
        <p className="mt-3 font-serif italic text-lg sm:text-xl text-sage" data-id="element-220" data-mp="1f20zl7ip9b46">
          Six volumes + five bonuses — the year, the week, the records, and the
          house around them.
        </p>

        <p className="mt-7 text-ink-soft leading-relaxed max-w-2xl mx-auto" data-id="element-221" data-mp="1osvn0f7omgr7">
          This is not a curriculum. Not a lesson planner. Not another pretty
          printable. It&apos;s the back office of your homeschool: the
          operations layer that wraps around whatever you already teach, however
          you already teach it — structured, relaxed, or somewhere in between.
          Six volumes of templates, checklists and cards built to be printed and
          used, not read.
        </p>

        <ul className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-222" data-mp="2ciq08xvwy7bz">
          {stats.map(stat => <li key={stat.label} className="rounded-2xl bg-cream border border-cream-dark px-4 py-5 text-sm font-semibold text-ink" data-id="element-223" data-mp="2hg8b4tthqwmm">
              <span className="block text-xl" aria-hidden="true" data-id="element-224" data-mp="1mu1dbdlr3kyf">
                {stat.emoji}
              </span>
              <span className="mt-2 block" data-id="element-225" data-mp="21rlavzgbiduk">{stat.label}</span>
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-226" data-mp="1wrp8g4n9quh4">
          {coverage.map(chip => <li key={chip} className="inline-flex items-center rounded-full bg-sage-tint border border-sage-soft px-3.5 py-2 text-xs sm:text-sm font-medium text-sage" data-id="element-227" data-mp="191l3ntycgooj">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}